module.exports = __webpack_public_path__ + "style/img/工业互联网标识数据服务系统.24d639ef.png";